import { My_pdf } from '~components/common/forms/My_pdf.js'
import { Form_img } from '~components/common/forms/Form_img.js'

export const blueprint_form_data_to_str_form_data = function (blueprint, form_data) {
  blueprint.forEach(enter_block => {
    switch(enter_block.type) {
      case 'output': case 'textarea': case 'input': case 'password': case 'number':
      case 'date': case 'input_onoff_text': case 'output_button':
      default: {
        if(form_data[enter_block.key] == null || form_data[enter_block.key] == undefined)
          form_data[enter_block.key] = '-';
        break;
      }
      case 'select': {
        let value = form_data[enter_block.key];
        let index = (enter_block.values || enter_block.options).indexOf(value);
        if(index != -1) form_data[enter_block.key] = enter_block.options[index];
        break;
      }
      case 'radio': {
        form_data[enter_block.key] = enter_block.options.map((option, index) => {
          let target_value = (enter_block.values || enter_block.options)[index];
          let result = target_value == form_data[enter_block.key];
          return (result ? '☑': '☐') + ' ' + option;
        });
        break;
      }
      case 'checkbox': {
        form_data[enter_block.key] = enter_block.options.map((option, index) => {
          let target_value = (enter_block.values || enter_block.options)[index];
          let result = (form_data[enter_block.key] || []).indexOf(target_value) != -1;
          return (result ? '☑': '☐') + ' ' + option;
        });
        break;
      }
      case 'onoff': case 'input_onoff': {
        form_data[enter_block.key] = (form_data[enter_block.key] ? '☑': '☐');
        break;
      }
      case 'outer': {
        blueprint_form_data_to_str_form_data(enter_block.blocks, form_data);
        break;
      }
      case 'radio_table': {
        form_data[enter_block.key] = enter_block.items.filter(item => !Array.isArray(item)).map((item, item_index) => {
          return enter_block.options.map((options, index) => {
            let target_value = (enter_block.values || enter_block.options)[index];
            let result = target_value == form_data[enter_block.key][item_index];
            return (result ? '☑': '☐') + ' ' + target_value;
          });
        });
        break;
      }
      case 'select_table': {
        enter_block.items.forEach((item, item_index) => {
          let value = form_data[enter_block.key][item_index];
          let index = (enter_block.values || enter_block.options).indexOf(value);
          if(index != -1) form_data[enter_block.key][item_index] = enter_block.options[index];
        });
        break;
      }
    }
  });
}

export const create_new_window_cnt = function (ratio, header_sq, content_sq) {
  let form_img = new Form_img(header_sq, content_sq, {
    ratio,
    padding_x: 20,
    padding_y: 0,
    font_family: 'Times New Roman',
    join_str: '　',
  });
  let canvas_arr = form_img.draw();
  return canvas_arr.map((canvas, index) => {
    let base64 = canvas.toDataURL('image/jpeg', 1.0);
    return `<img width="100%" src="${base64}">`;
  }).join('');
}

export const create_pdf_data_url = function (ratio, header_sq, content_sq) {
  let my_pdf = new My_pdf({
    page_width: 841 * ratio,
    page_height: 1189 * ratio,
  });
  let form_img = new Form_img(header_sq, content_sq, {
    padding_x: 50,
    padding_y: 30,
    font_family: 'Times New Roman',
    join_str: '　',
    ratio,
  });
  let canvas_arr = form_img.draw();
  canvas_arr.forEach((canvas, index) => {
    let base64 = canvas.toDataURL('image/jpeg', 1.0);
    my_pdf.appendImg('page' + index, base64, canvas.width, canvas.height);
    my_pdf.appendPage([ {type: 'img', img: 'page' + index, x: 0, y: 0} ]);
  });
  return my_pdf.getDataUrl();
}